<template>
    <div>
        <draggable v-model="selectedFiles" group="files" @end="updateSort" class="images-preview-container" v-if="selectedFiles.length">
            <div class="relative preview-margin image-container" v-for="(f, idx) in selectedFiles" :key="idx">
                <img class="preview-img-container preview-img-picker" :src="f.filename_thumb" />
                <div v-if="showFeatured && idx === 0" class="featured-img">Featured</div>
                <div class="trash-btn-container">
                    <div class="trash-btn" @click="removeFile(idx)">
                        <b-icon icon="delete" type="is-danger" />
                    </div>
                </div>
            </div>
        </draggable>
        <b-button type="is-primary" @click="isModal = true">Select {{ fileType }}</b-button>
        <b-modal :active.sync="isModal" full-screen custom-class="regular-font">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Choose a file</p>
                </header>
                <section class="modal-card-body">
                    <GalleryComponent @select="fileSelected" :type="type" picker :multiple="multiple" />
                </section>
                <footer class="modal-card-foot">
                    <b-button label="Close" @click="isModal = false" />
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import GalleryComponent from "./GalleryComponent.vue";
export default {
    name: "GalleryPicker",
    components: {
        Draggable,
        GalleryComponent,
    },
    props: {
        type: {
            type: String, // 'image', 'document', 'podcast', '*'
            default: "*",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        initial: {},
        showFeatured: {
            type: Boolean,
            default: false,
        },
        alwaysArray: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isModal: false,
            selectedFiles: [],
        };
    },
    methods: {
        updateSort() {
            this.$emit(
                "select",
                this.selectedFiles.map((f) => f.id)
            );
        },
        fileSelected(file) {
            if (this.multiple) {
                // Check if duplicated
                if (this.selectedFiles.some((f) => f.id == file.id)) {
                    this.notify("File already selected", "is-warning", 500);
                    return;
                }
                this.selectedFiles.push(file);
                this.$emit(
                    "select",
                    this.selectedFiles.map((f) => f.id)
                );
            } else {
                this.selectedFiles = [file];
                this.$emit("select", this.alwaysArray ? [file.id] : file.id);
                this.isModal = false;
            }
            this.notify("You file is selected", "is-success", 500);
        },
        removeFile(idx) {
            this.selectedFiles.splice(idx, 1);
            let tmp = this.alwaysArray ? this.selectedFiles.map((f) => f.id) : null;
            this.$emit("select", tmp);
        },
    },
    computed: {
        fileType() {
            switch (this.type) {
                case "image":
                    return "Image";
                case "document":
                    return "Document";
                case "podcast":
                    return "Podcast";
                default:
                    return "File";
            }
        },
    },
    watch: {
        initial(val) {
            if (val == null) {
                this.selectedFiles = [];
            } else {
                if (Array.isArray(val)) {
                    this.selectedFiles = val;
                } else {
                    // if object or null
                    this.selectedFiles = [val];
                }
            }
        },
        multiple(val) {
            console.log("alwaysArray: ", this.alwaysArray);
            if (val) {
                // multiple
                console.log("multiple is true now");
                this.$emit(
                    "select",
                    this.selectedFiles.map((f) => f.id)
                );
            } else {
                // single file
                this.selectedFiles.splice(1);
                let tmp = null;
                if (this.selectedFiles.length) {
                    tmp = this.selectedFiles[0].id;
                } else if (this.alwaysArray) {
                    tmp = [];
                } else {
                    tmp = null;
                }
                console.log("select event: ", tmp);
                this.$emit("select", tmp);
            }
        },
    },
    mounted() {
        if (this.initial == null) {
            this.selectedFiles = [];
        } else {
            if (Array.isArray(this.initial)) {
                this.selectedFiles = this.initial;
            } else {
                // if object or null
                this.selectedFiles = [this.initial];
            }
        }
    },
};
</script>

<style>
.regular-font {
    font-weight: 400 !important;
}
.preview-margin {
    margin: 0px 5px;
}
.preview-img-container {
    padding: 10px;
    box-shadow: 0px 0px 8px rgb(0 0 0 / 16%);
}
.preview-img-picker {
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: default;
}
.images-preview-container {
    display: flex;
    flex-wrap: wrap;
}
.images-preview-container .trash-btn-container {
    margin: 10px;
}
.featured-img {
    position: absolute;
    bottom: 15px;
    right: 8px;
    background: white;
    padding: 0px 6px;
    border-radius: 16px 0px 0px 0px;
    font-weight: bold;
}
</style>